module.exports = __webpack_public_path__ + "img/btn_loading.89517828.gif";